import { FC } from 'react';
import Button from '../common/Button';
import { downloadCsv } from '../../api/downloadCsv';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../redux/store';
import { setTokens } from '../../redux/tokenSlice';
import { getMaintenanceInfo } from '../../api/maintenance';
import { setMaintenanceInfo } from '../../redux/maintenanceSlice';
import { ApiErrorData } from '../../types/errors';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { enqueueError } from '../../redux/errorSlice';

type CsvType = 'workTimes' | 'company' | 'car' | 'driver';
type Props = {
  type: CsvType;
  date?: string;
  disabled?: boolean;
};
const CsvDownload: FC<Props> = ({ type, date, disabled }) => {
  const dispatch = useDispatch<AppDispatch>();
  const refreshToken = useSelector(
    (state: AppState) => state.tokens.refreshToken
  );
  const handleDLcsv = async () => {
    try {
      const res = await downloadCsv(type, date);
      const csvData = await res.blob();

      //BLOB生成してダウンロード実行
      if (res) {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const headerData = res.headers.get('Content-Disposition');
        const fileName = headerData && headerData.match(/ filename="(.*)"/);
        const csvFileName = fileName && fileName[1];
        a.download = csvFileName ? csvFileName : 'csvFile.csv';
        const clickHandler = () => {
          // CSVダウンロード処理後にrevokeObjectURLが動くようにするため、setTimeoutを使用
          setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener('click', clickHandler);
          }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
      }
    } catch (e) {
      if (!(e instanceof Response)) {
        // Response 型でない場合、ネットワークエラーなどの Error オブジェクトとして扱う
        dispatch(enqueueError(e as Error));
        return;
      }
      // Response 型の場合、リトライが必要であったり ErrorModal の想定しているエラー型でなかったりするので
      // 自前でハンドリング処理を実施する
      if (e.status === 401) {
        const { accessToken } = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/v1/auth/access-token`,
          {
            method: 'POST',
            body: JSON.stringify({
              refreshToken,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          }
        ).then((res) => res.json() as Promise<{ accessToken: string }>);
        dispatch(
          setTokens({
            accessToken,
            refreshToken,
          })
        );
        handleDLcsv();
        return;
      } else if (e.status === 503) {
        // エラーオブジェクトからメッセージ取得
        const errorMessage = ((await e.json()) as ApiErrorData).message;
        getMaintenanceInfo().then((maintenance) => {
          if (maintenance.isMaintenance) {
            dispatch(setMaintenanceInfo(maintenance));
            return;
          }
          const unavailableError = new Error(errorMessage);
          dispatch(enqueueError(unavailableError));
        });
      } else {
        const err: FetchBaseQueryError = {
          status: e.status,
          data: await e.json(),
        };
        dispatch(enqueueError(err));
      }
    }
  };

  return (
    <Button
      variants={['cancel', 'contain']}
      disabled={disabled}
      onClick={() => handleDLcsv()}
    >
      CSV出力
    </Button>
  );
};

export default CsvDownload;
